<p-toast></p-toast>

<div class="grid mx-3">
  <div class="col-12 sm:col-6 py-2" *ngIf="generalInfo === null">
    <p-skeleton width="12rem" styleClass="mb-2" />
    <p-skeleton width="7rem" styleClass="mb-2" />
    <p-skeleton width="10rem" styleClass="mb-2" />
  </div>

  <div class="col-12 sm:col-6 py-2" *ngIf="generalInfo === null">
    <p-skeleton width="10rem" styleClass="mb-2" />
    <p-skeleton width="12rem" styleClass="mb-2" />
    <p-skeleton width="7rem" styleClass="mb-2" />
  </div>

  <div class="col-12 sm:col-6" *ngIf="generalInfo">
    <p>
      <b>Deposit Date:</b> {{ generalInfo.depositDate ? (generalInfo.depositDate | date:'MM/dd/yyyy') : 'N/A' }}<br />
      <b>Conversion Date:</b> {{ generalInfo.conversionDate ? (generalInfo.conversionDate | date:'MM/dd/yyyy') : 'N/A' }}
    </p>
    <p>
      <b>Refunded Amount:</b> ${{ generalInfo.refundAmount || 0 }}<br />
      <b>Pledged:</b> {{ generalInfo.isPledged ? 'Yes' : 'No' }}<br />
      <b>Batch Name:</b> {{ generalInfo.batchName || 'N/A' }}
    </p>
  </div>
  <div class="col-12 sm:col-6" *ngIf="generalInfo">
    <p>
      <b>Source:</b> {{ generalInfo.source || 'N/A' }}<br />
      <b>Type:</b> {{ generalInfo.contributionType || 'N/A' }}
    </p>
    <p>
      <b>Event Code:</b> {{ generalInfo.eventCode || 'N/A' }}<br />
      <b>Trx ID:</b> {{ generalInfo.transactionId || 'N/A' }}<br />
      <b>Entered by:</b> {{ generalInfo.enteredBy || 'N/A' }}
    </p>
  </div>
</div>

<!-- Edit Modal -->
<p-dialog 
  header="Edit General Info" 
  [(visible)]="isEditModalVisible" 
  [modal]="true" 
  [maximizable]="true" 
  draggable="false" 
  styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

  <div>
    <div ngClass="medium loader-wrapper" *ngIf="isEditDataLoading">
      <rc-loading-spinner></rc-loading-spinner>
    </div>

    <form [formGroup]="editForm" *ngIf="!isEditDataLoading">
      <p-card>
        <div class="formgrid grid">
          <!-- Donation Date Field -->
          <div class="field col-12 md:col-4 lg:col-4">
            <label class="required">Donation Date</label>
            <p-calendar 
              formControlName="donationDate" 
              showIcon 
              iconDisplay="input" 
              dateFormat="mm/dd/yy" 
              placeholder="MM/DD/YYYY" 
              [showOnFocus]="false" 
              [ngClass]="{ 'ng-invalid': isInvalid('donationDate') }">
            </p-calendar>
            <small class="p-error" *ngIf="isInvalid('donationDate')">Donation Date is required</small>
          </div>

          <div class="field col-12 md:col-4 lg:col-4">
            <label class="required">Donation Amount</label>
            <input 
              pInputText 
              formControlName="donationAmount" 
              type="text"
              (input)="onAmountInput($event, 'donationAmount')"
              [disabled]="true" 
              [ngClass]="{ 'ng-invalid': isInvalid('donationAmount') }" />
            <small class="p-error" *ngIf="isInvalid('donationAmount')">Donation Amount is required</small>
          </div>

          <!-- Refund Amount Field -->
          <div class="field col-12 md:col-4 lg:col-4">
            <label>Refund Amount</label>
            <input pInputText
                   formControlName="refundAmount"
                   type="text"
                   (input)="onAmountInput($event, 'refundAmount')"
                   [ngClass]="{ 'ng-invalid': isInvalid('refundAmount') }" />
            <div class="p-error" *ngIf="editForm.get('refundAmount')?.hasError('refundExceedsDonation') && editForm.get('refundAmount')?.touched">
              Refund amount cannot exceed donation amount.
            </div>
            <div class="p-error" *ngIf="editForm.get('refundAmount')?.hasError('refundBelowApiAmount') && editForm.get('refundAmount')?.touched">
              Refund amount is less than sum of refund amounts of compliance letters {{apiRefundAmount}}.
            </div>
          </div>
          <div class="field col-12 md:col-4 lg:col-4">
            <label class="required">Event Code</label>
            <p-autoComplete formControlName="eventCode"
                            [suggestions]="filteredEventCodes"
                            (completeMethod)="filterEventCodes($event)"
                            (onSelect)="onEventCodeSelect($event)"
                            optionLabel="text"
                            optionValue="value"
                            placeholder="Type to Search">
            </p-autoComplete>
            <small class="p-error" *ngIf="isInvalid('eventCode')">Event Code is required</small>
          </div>
          <div class="field col-12 md:col-4 lg:col-4">
            <label class="required">Source</label>
            <p-dropdown formControlName="source"
                        [options]="sourceOptions"
                        placeholder="Please Select"
                        optionLabel="text"
                        optionValue="value"
                        [ngClass]="{ 'ng-invalid': isInvalid('source') }">
            </p-dropdown>
            <small class="p-error" *ngIf="isInvalid('source')">Contribution Source is required</small>
          </div>
          <div class="field col-12 md:col-4 lg:col-4">
            <label class="required">Type</label>
            <p-dropdown formControlName="type"
                        [options]="typeOptions"
                        placeholder="Please Select"
                        optionLabel="text"
                        optionValue="value"
                        [ngClass]="{ 'ng-invalid': isInvalid('type') }">
            </p-dropdown>
            <small class="p-error" *ngIf="isInvalid('type')">Contribution Type is required</small>
          </div>
          <div class="field col-12 md:col-4 lg:col-4">
            <label>Pledged</label>
            <p-inputSwitch formControlName="isPledged"></p-inputSwitch>
          </div>
          <div class="field col-12 md:col-4 lg:col-4">
            <label>Conversion Date</label>
            <p-calendar formControlName="conversionDate" showIcon iconDisplay="input" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY"
                        [ngClass]="{ 'ng-invalid': isInvalid('conversionDate') }"></p-calendar>
          </div>
          <div class="field col-12 md:col-4 lg:col-4">
            <label class="required">Fund Code</label>
            <p-autoComplete formControlName="fundCode"
                            [suggestions]="filteredFundCodes"
                            (completeMethod)="filterFundCodes($event)"
                            (onSelect)="onFundCodeSelect($event)"
                            optionLabel="text"
                            optionValue="value"
                            placeholder="Type to Search">
            </p-autoComplete>
            <small class="p-error" *ngIf="isInvalid('fundCode')">Fund Code is required</small>
          </div>
        </div>
      </p-card>
      <div class="imported-dialog-footer">
        <p-button label="Cancel" type="button" [text]="true" (click)="onEditCancel()"></p-button>
        <p-button label="Save" severity="primary" type="button" (click)="onEditSubmit()" [disabled]="isReadOnlyMode"></p-button>
      </div>
    </form>
  </div>
</p-dialog>
